import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiClientError } from '@/lib/api-client';
import { listStagingRows, patchStagingRow, type PatchStagingRowInput } from './api';
import type { StagingRowDto, StagingRowListParams, StagingRowListResult } from './types';

const KEY = 'staging-rows' as const;

export const stagingRowsKey = (jobId: string, params: StagingRowListParams) =>
  [KEY, jobId, params] as const;

export const useStagingRows = (jobId: string | undefined, params: StagingRowListParams = {}) => {
  return useQuery<StagingRowListResult, ApiClientError>({
    queryKey: [KEY, jobId ?? '', params],
    queryFn: () => listStagingRows(jobId as string, params),
    enabled: !!jobId,
    placeholderData: (prev) => prev,
  });
};

export const usePatchStagingRow = (jobId: string | undefined) => {
  const qc = useQueryClient();
  return useMutation<StagingRowDto, ApiClientError, PatchStagingRowInput>({
    mutationFn: (input) => patchStagingRow(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, jobId ?? ''] }),
  });
};
